import { z } from 'zod';
import { ORDER_STATUSES } from '../constants.js';

export const TRACKING_CARRIERS = ['ctt'] as const;
export type TrackingCarrier = (typeof TRACKING_CARRIERS)[number];

export const orderStatusUpdateSchema = z
  .object({
    status: z.enum(ORDER_STATUSES),
    note: z.string().max(1000).optional(),
    trackingCarrier: z.enum(TRACKING_CARRIERS).optional(),
    trackingNumber: z.string().min(3).max(100).optional(),
  })
  .superRefine((value, ctx) => {
    if (value.status === 'shipped') {
      if (!value.trackingCarrier) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['trackingCarrier'],
          message: 'Transportadora obrigatória para estado "Expedida".',
        });
      }
      if (!value.trackingNumber) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['trackingNumber'],
          message: 'Número de rastreio obrigatório para estado "Expedida".',
        });
      }
    }
  });

export const orderListQuerySchema = z.object({
  status: z.enum(ORDER_STATUSES).optional(),
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
  search: z.string().optional(),
  sort: z.enum(['createdAt', 'total']).default('createdAt'),
  dir: z.enum(['asc', 'desc']).default('desc'),
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export const orderInternalNotesSchema = z.object({
  internalNotes: z.string().max(5000),
});

export type OrderStatusUpdateInput = z.infer<typeof orderStatusUpdateSchema>;
export type OrderListQuery = z.infer<typeof orderListQuerySchema>;
export type OrderInternalNotesInput = z.infer<typeof orderInternalNotesSchema>;
